module.exports = __webpack_public_path__ + "media/images/deviant-9bd4515defd05b76b33577c007ebc5a9.png";